import { createTheme as t } from "@mui/material/styles";
const i = t({
  cssVariables: {
    colorSchemeSelector: "class"
  },
  colorSchemes: {
    light: !0,
    dark: !1
  },
  breakpoints: {
    values: {
      xs: 300,
      sm: 600,
      md: 900,
      lg: 1500,
      xl: 2e3
    }
  },
  spacing: 4,
  palette: {
    primary: {
      main: "#226A58",
      light: "#ABD9CE",
      dark: "#1A5F4E"
    },
    secondary: {
      main: "#009688"
    },
    aTandT: {
      main: "#067AB4"
    },
    blue: {
      400: "#4B71FF",
      300: "#738DFF",
      200: "#A0AEFF"
    },
    bluegrey: {
      900: "#222325",
      750: "#5C6473",
      700: "#5D6169",
      600: "#747982",
      400: "#C5C8CE",
      100: "#CDD2DB"
    },
    blueViolet: {
      500: "#5158BB",
      300: "#838CD0",
      100: "#C9CDEB"
    },
    deepFuchsia: {
      300: "#CE5ACA",
      200: "#DD8CD9",
      100: "#EABBE8"
    },
    grey: {
      900: "#141414",
      700: "#5B5B5B",
      600: "#878787",
      200: "#EFEFEF",
      100: "#F7F7F7",
      50: "#FFFFFF"
    },
    tealBlue: {
      300: "#4BBFB9",
      100: "#B3E3E1",
      50: "#E1F4F4"
    },
    tMobile: {
      main: "#E20074"
    },
    terraCotta: {
      500: "#DB4C63",
      300: "#E7738F",
      200: "#EE98AE"
    },
    yellowOrange: {
      400: "#FFA600",
      200: "#FFCB78",
      100: "#FFE0AE"
    },
    verizon: {
      main: "#D52B1E"
    }
  },
  typography: {
    fontSize: 12,
    fontFamily: "Inter, sans-serif"
  },
  transitions: {
    duration: {
      enteringScreen: 200,
      leavingScreen: 100
    }
  },
  components: {
    // Name of the component ⚛️
    MuiButtonBase: {
      defaultProps: {
        // The props to apply
        disableRipple: !0
        // No more ripple, on the whole application 💣
      }
    },
    MuiButton: {
      defaultProps: {
        size: "small",
        variant: "contained"
      },
      styleOverrides: {
        root: {
          textTransform: "uppercase"
        }
      }
    },
    MuiTab: {
      defaultProps: {
        iconPosition: "start"
      },
      styleOverrides: {
        root: {
          minHeight: 32,
          fontFamily: "Inter, sans-serif",
          fontSize: "12px",
          letterSpacing: "normal"
        }
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: ({
          ownerState: e
        }) => e.variant === "standard" ? {
          "& .MuiInputBase-input": {
            boxSizing: "content-box !important"
          }
        } : {}
      }
    },
    MuiAlert: {
      styleOverrides: {
        standardSuccess: {
          backgroundColor: "#E8F5E9",
          color: "#1E4620"
        },
        icon: {
          "&.MuiAlert-icon": {
            opacity: 1,
            color: "#1E4620"
          }
        }
      }
    },
    MuiOutlinedInput: {
      defaultProps: {
        size: "small"
      }
      // styleOverrides: {
      //   root: {
      //     borderRadius: "6px",
      //     height: 32,
      //     // ensure the outline matches the root radius
      //     "& .MuiOutlinedInput-notchedOutline": {
      //       borderRadius: "6px"
      //     }
      //   },
      //   input: {
      //     height: "32px",
      //   }
      // }
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          borderRadius: "6px",
          height: 32
        },
        input: {
          height: "32px"
        }
      }
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: ({
          ownerState: e
        }) => ({
          fontSize: e?.fontSize === "small" ? "1rem" : e?.fontSize === "medium" ? "1.25rem" : void 0
        })
      }
    },
    // @ts-expect-error - MUI X TreeItem not declared in core Components type
    MuiTreeItem: {
      styleOverrides: {
        content: {
          padding: "0 8px",
          "&.Mui-selected.Mui-focused": {
            backgroundColor: "rgba(2, 105, 81, 0.08)"
          }
        }
      }
    }
  }
});
export {
  i as theme
};
